import React from 'react'
import "../styles/slides.css"

const Slides = () => {
  return (
    <div>
<div className="slider">
	<div className="slide-track">
		<div className="slide">
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="" /> */}
            <div className="ccl">Adane</div>
		</div>
		<div className="slide">
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="" /> */}
             <div  className="ccl">Adane</div>
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/1.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/2.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/3.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/4.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/5.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/6.png" height="100" width="250" alt="" /> */}
		</div>
		<div className="slide">
             <div  className="ccl">Adane</div>
			{/* <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/557257/7.png" height="100" width="250" alt="" /> */}
		</div>
	</div>
</div>

    </div>
  )
}

export default Slides